var map = {
	"./code.svg": [
		1257,
		40
	],
	"./crystal.svg": [
		1258,
		41
	],
	"./database.svg": [
		1259,
		42
	],
	"./defaultProduct.svg": [
		1260,
		43
	],
	"./maintenanceProduct.svg": [
		1261,
		44
	],
	"./parameters.svg": [
		1262,
		45
	],
	"./refresh.svg": [
		1263,
		46
	],
	"./school.svg": [
		1264,
		47
	],
	"./search.svg": [
		1265,
		48
	],
	"./tokens.svg": [
		1266,
		49
	],
	"./web.svg": [
		1267,
		50
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1152;
module.exports = webpackAsyncContext;